import Home from "./views/Home";

const App = () => {
  return (
    <Home />
  )
}

export default App
